// extracted by mini-css-extract-plugin
module.exports = {"container":"SelectedLandingPage_container__15wj5","selectedLandingPage":"SelectedLandingPage_selectedLandingPage__2h1JN"};